<template>
  <!-- アポイントメント一覧検索 -->
  <div id="AppAppointmentSearch">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">予約検索</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検期間" labelPosition="on-border">
              <b-datepicker
                v-model="startDate"
                name="startDate"
                placeholder="検索開始年月日"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              ></b-datepicker>
              <b-datepicker
                v-model="endDate"
                name="endDate"
                placeholder="検索終了年月日"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              ></b-datepicker>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="点検担当者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="点検担当者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffName"
                name="staffName"
                data-vv-as="点検担当者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field
              label="予約番号"
              labelPosition="on-border"
              :type="{'is-danger':errors.has('appointmentCode')}"
              :message="errors.first('appointmentCode')"
            >
              <b-input
                v-model="searchConditions.appointmentCode"
                name="appointmentCode"
                data-vv-as="予約番号"
                type="text"
                v-validate="'numeric'"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="住所" labelPosition="on-border">
              <b-input
                v-model="searchConditions.address"
                name="address"
                data-vv-as="住所"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-two-third">
            <b-field label="実施状況" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.appointmentStatusGroup"
                native-value="1"
              >アポ未実施</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.appointmentStatusGroup"
                native-value="2"
              >アポ実施済</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.appointmentStatusGroup"
                native-value="3"
              >点検中</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.appointmentStatusGroup"
                native-value="6"
              >点検完了</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.appointmentStatusGroup"
                native-value="5"
              >取り消し</b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
            <span style="color: red" v-if="isSearchConditionAll">全件検索となる為、検索条件を絞り込んでください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <appointmentSearchResult
      ref="searchResult"
      v-bind:search-conditions="searchConditions"
      style="margin-left: 50px; margin-right: 50px;"
      @search="search()"
    />
  </div>
</template>

<script>
import AppointmentSearchResultTemplate from "./AppAppointmentSearchResult";
var data = [];
export default {
  name: "AppAppointmentSearch",
  methods: {
    search: function(searchConditions) {
      if (
        this.startDate ||
        this.endDate ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.appointmentCode) ||
        this.isLength(this.searchConditions.address) ||
        this.searchConditions.appointmentStatusGroup.length > 0
      ) {
        console.log("検索条件あり");
        this.isSearchConditionNull = false;
        if (
          !this.startDate &&
          !this.endDate &&
          !this.isLength(this.searchConditions.officeCode) &&
          !this.isLength(this.searchConditions.staffCode) &&
          !this.isLength(this.searchConditions.staffName) &&
          !this.isLength(this.searchConditions.address) &&
          !this.isLength(this.searchConditions.appointmentCode)
        ) {
          if (
            this.isSearchAll([
              this.searchConditions.appointmentStatusGroup.length,
              5
            ])
          ) {
            this.isSearchConditionAll = true;
            return;
          }
        }
        this.isSearchConditionAll = false;
        // 検索条件の整形
        if (this.startDate && !(typeof this.startDate == "string")) {
          this.searchConditions.startDate = this.formatDate(this.startDate);
        }
        if (this.endDate && !(typeof this.endDate == "string")) {
          this.searchConditions.endDate = this.formatDate(this.endDate);
        }
        for (var val in this.searchConditions.appointmentStatusGroup) {
          this.searchConditions.appointmentStatusGroup[val] = parseInt(
            this.searchConditions.appointmentStatusGroup[val]
          );
        }
        // 検索実行
        this.$validator.validateAll().then(validatorResult => {
          if (validatorResult) {
            this.$refs.searchResult.search(this.searchConditions);
          }
        });
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionAll = false;
        this.isSearchConditionNull = true;
      }
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var searchConditions = {
      officeCode: "",
      startDate: "",
      endDate: "",
      staffCode: "",
      staffName: "",
      address: "",
      appointmentStatusGroup: [],
      appointmentCode: ""
    };
    var startDate = null;
    var endDate = null;

    if (this.$route.params["searchConditions"]) {
      searchConditions = this.$route.params["searchConditions"];
      if (
        typeof searchConditions.startDate == "string" &&
        searchConditions.startDate != ""
      ) {
        startDate = this.parseDate(searchConditions.startDate);
      }
      if (
        typeof searchConditions.endDate == "string" &&
        searchConditions.endDate != ""
      ) {
        endDate = this.parseDate(searchConditions.endDate);
      }
    } else {
      if (userInfo.roleId != 1 && userInfo.roleId != 2) {
        searchConditions.officeCode = userInfo.officeCode;
        searchConditions.staffCode = userInfo.staffCode;
        searchConditions.staffName = userInfo.fullName;
        searchConditions.appointmentStatusGroup = ["1", "2", "3"];
      }
    }
    return {
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      isStaffChangeModalActive: false,
      isAddAppointmentActive: false,
      searchConditions,
      startDate,
      endDate,
      isSearchConditionNull: false,
      isSearchConditionAll: false,
      userInfo
    };
  },
  filters: {},
  components: {
    appointmentSearchResult: AppointmentSearchResultTemplate
  },
  mounted: function() {
    //サイドメニューから遷移時は初期検索をしない
    if (this.$route.params["searchConditions"]) {
      this.search();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppAppointmentSearch.vue